import { messages as commonMessages } from '../../Scheduler.messages';

export const monthsItems = [
    {
        id: 'jan',
        name: commonMessages.januaryShort,
    },
    {
        id: 'feb',
        name: commonMessages.februaryShort,
    },
    {
        id: 'mar',
        name: commonMessages.marchShort,
    },
    {
        id: 'apr',
        name: commonMessages.aprilShort,
    },
    {
        id: 'may',
        name: commonMessages.mayShort,
    },
    {
        id: 'jun',
        name: commonMessages.juneShort,
    },
    {
        id: 'jul',
        name: commonMessages.julyShort,
    },
    {
        id: 'aug',
        name: commonMessages.augustShort,
    },
    {
        id: 'sep',
        name: commonMessages.septemberShort,
    },
    {
        id: 'oct',
        name: commonMessages.octoberShort,
    },
    {
        id: 'nov',
        name: commonMessages.novemberShort,
    },
    {
        id: 'dec',
        name: commonMessages.decemberShort,
    },
];

export const monthNumbers = monthsItems.map((_, i) => ({
    id: (i + 1).toString(),
    name: (i + 1).toString(),
}));
